// @flow

// Vendors
import React, { Suspense } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import routes from './config/routes';

// Global Styles
import './styles/index.scss';

// Components
import { Page, Loader, Nav, Footer } from './components';

const App = () => (
  <Router basename={process.env.PUBLIC_URL}>
    <Nav />
    <Switch>
      {routes.map(({ path, exact, ...routeProps }) => (
        <Route key={path} exact={exact} path={path}>
          <Suspense fallback={<Loader />}>
            <Page {...routeProps} />
          </Suspense>
        </Route>
      ))}
    </Switch>
    <Footer />
  </Router>
);

export default App;
